<mat-toolbar color="primary" id="header">
  <mat-toolbar-row>
    <div style="cursor: pointer" (click)="router.navigate(['/inicio'])">
      <img
        src="../assets/images/Fosil-logo-white.png"
        style="width: 50px"
        alt=""
      />
      <span style="margin-left: 10px">Fosil</span>
    </div>
    <span class="example-spacer"></span>
    <div *ngIf="size > 1000" style="width: 100%">
      <h2 class="company-name">{{ companyName }}</h2>
    </div>
    <div
      style="margin: 6px 30px 0 0; cursor: pointer"
      *ngIf="nombreUsuario != ''"
    >
      <mat-icon
        [matMenuTriggerFor]="beforeMenu"
        [matBadge]="notifications.length"
        matBadgeColor="warn"
        >notification_important</mat-icon
      >
      <span class="cdk-visually-hidden"> </span>

      <mat-menu #beforeMenu="matMenu" xPosition="before">
        <div *ngFor="let data of notifications">
          <div
            style="height: 70px"
            mat-menu-item
            (click)="redirect(data, $event)"
          >
            <h3 style="margin: -2px 0 0 0; padding: 0">
              <strong>{{ data.title }}</strong>
            </h3>
            <p style="margin: -15px 0 0px; padding: 0; font-size: 0.8rem">
              {{ data.description }}
            </p>
          </div>
        </div>
      </mat-menu>
    </div>
    <h4 style="color: white; margin-right: 20px">
      {{ nombreUsuario | uppercase }}
    </h4>
    <mat-icon
      [matMenuTriggerFor]="menu"
      matRipple
      class="menu_more_vert"

      *ngIf="logged"
      aria-label="Example delete icon"
      >more_vert</mat-icon
    >
    <mat-menu #menu="matMenu">
      <button mat-menu-item routerLink="/administracion/perfil">
        <mat-icon  aria-label="Example home icon"
          >accessibility</mat-icon
        >
        Perfil
      </button>
      <button mat-menu-item (click)="Logout()">
        <mat-icon  aria-label="Example home icon"
          >power_settings_new</mat-icon
        >
        Salir
      </button>
    </mat-menu>

  </mat-toolbar-row>
</mat-toolbar>

<div style="display: flex; width: 100%;">
  <div *ngIf="logged && size > minimalScreen && !isMobile" >
    <app-side-bar [active]="activeSideBar" (handlerSideBarEvent)="handlerSideBarEvent($event)"></app-side-bar>
  </div>

  <div 
    [style.max-height.vh]="mainRouterHeight"
    style="overflow-y: scroll; width: 100%;" 
  >
    <div class="fixed-breadcrumb" *ngIf="logged" #breadcrumbElement>
      <app-bread-crumb [menu]="menuBreadCrumb" (selectRouter)="eventService.emitEventBreadCumb($event)"></app-bread-crumb>
    </div>
    
    <div [style.padding-top.px]="breadcrumbHeight">
      <router-outlet
        (activate)="componentAdded($event)"
        (deactivate)="componentRemoved($event)"
      ></router-outlet>
    </div>

    <div class="iconHome" *ngIf="logged && size > 813 && size < minimalScreen">
      <button
        color="warn"
        mat-fab
        aria-label="Inicio"
        (click)="router.navigate(['/inicio'])"
      >
        <mat-icon>home</mat-icon>
      </button>
    </div>
  </div>
</div>
